import { render, staticRenderFns } from "./WordCloudChart.vue?vue&type=template&id=15bf99a0"
import script from "./WordCloudChart.vue?vue&type=script&lang=js"
export * from "./WordCloudChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports